import { QuestionIcon } from '@phosphor-icons/react'
import { mappedColors } from '@pixee/design-system'
import { match } from 'ts-pattern'
import { type TriageAnalyzerStrategy } from '../../utils/api-client/api-schemas'
import { TooltipWithHover } from '../tooltip'
import * as styles from './analyzer-strategy-tag.css.ts'

type AnalyzerStrategyTagProps = {
  strategy: TriageAnalyzerStrategy
  mappedRule?: string | null
}

type TagConfig = {
  text: string
  tooltip: string
}

export const AnalyzerStrategyTag: React.FC<AnalyzerStrategyTagProps> = ({ strategy, mappedRule }) => {
  const tagConfig = match(strategy)
    .with('dynamic', (): TagConfig => ({
      text: 'Using Adaptive triage',
      tooltip: "Elements of this finding's triage plan were dynamically generated by Pixee",
    }))
    .with('linter', (): TagConfig => ({
      text: 'Using Linter triage',
      tooltip: 'Linter rule findings are generally high confidence, but low impact, leading to this triage outcome',
    }))
    .with('auto_mapped', (): TagConfig => ({
      text: 'Auto-Mapped',
      tooltip: mappedRule
        ? `This rule was automatically mapped to ${mappedRule}`
        : 'This rule was automatically mapped',
    }))
    .with('static', () => null)
    .exhaustive()

  if (tagConfig === null) {
    return null
  }

  return (
    <span className={styles.tag}>
      {tagConfig.text}
      <TooltipWithHover
        trigger={
          <QuestionIcon
            size={12}
            weight="light"
            style={{
              color: mappedColors.neutral.orbit,
            }}
          />
        }
        side="top"
        maxWidth={220}
      >
        {tagConfig.tooltip}
      </TooltipWithHover>
    </span>
  )
}
